import { sessionUser } from 'utility/sessionStorageHelper';

export const remittanceURL = endpoint => {
  const { customerId, userId } = sessionUser.getLoggedInUser().getId();
  return `remittanceadvicesvc/v0/cust/${customerId}/user/${userId}/` + endpoint;
};
